<button class="cheader-menu__modify" (click)="toggleGlobalCustomerHeader()">
  <span *ngIf="!isCustomerVisible">
    顧客管理表を開く
  </span>
  <span *ngIf="isCustomerVisible">
    顧客管理表を閉じる（更新）
  </span>
  <span
    class="cheader-menu__modify__arrow"
    [class.cheader-menu__modify__arrow--down]="!isCustomerVisible"
    [class.cheader-menu__modify__arrow--up]="isCustomerVisible"
  ></span>
</button>

<div
  class="cheaderc"
  *ngIf="isCustomerVisible"
>
  <div *ngIf="userHasManagementRole" class="cheader-header">
    <ng-container *ngIf="userHasManagementRole">
      <div
        *ngFor="let team of authService.loginUser?.managementTeams"
        class="cheader-header__item btn"
        [ngClass]="{
          'btn--blue': selectedManagementTeamId === team.id,
          'link blue': selectedManagementTeamId !== team.id
        }"
        (click)="updateTableDataWithTeamId(team.id)"
      >
        {{ team.name }}
      </div>
      <div
        class="cheader-header__item btn"
        [ngClass]="{
          'btn--blue': !selectedManagementTeamId,
          'link blue': selectedManagementTeamId
        }"
        (click)="updateTableDataWithTeamId(null)"
      >
        個人
      </div>
    </ng-container>
  </div>
  <!-- 検索条件ボタン -->
  <div class="cheader-filter-bar">
    <button
      class="btn btn--small btn--blue cheader-filter-bar__btn"
      (click)="openFilterDialog()"
    >
      検索条件
    </button>
    <ag-chip
      *ngFor="let condition of savedConditions"
      class="chip chip--green cheader-filter-bar__chip"
      [label]="condition.name"
      [selected]="condition.id === selectedSavedConditionId"
      (toggled)="onSavedConditionToggled($event, condition)"
      (removed)="onSavedConditionRemoved(condition)"
    ></ag-chip>
  </div>
  <div *ngIf="appliedFilterLabel" class="cheader-filter-label">
    {{ appliedFilterLabel }}
  </div>
  <!-- ページネーション -->
  <div class="cheader-pagination">
    <div class="cheader-pagination__range">全{{totalFilteredCount}}件中 {{pageRangeStart}}件〜{{pageRangeEnd}}件を表示</div>
    <button
      class="cheader-pagination__btn"
      [disabled]="currentPage === 1"
      (click)="goToPage(currentPage - 1)"
    >&lt; 前へ</button>
    <ng-container *ngFor="let p of pageNumbers">
      <span *ngIf="p === '...'" class="cheader-pagination__ellipsis">...</span>
      <button
        *ngIf="p !== '...'"
        class="cheader-pagination__btn"
        [class.cheader-pagination__btn--active]="p === currentPage"
        (click)="goToPage(+p)"
      >{{ p }}</button>
    </ng-container>
    <button
      class="cheader-pagination__btn"
      [disabled]="currentPage === totalPages || totalPages === 0"
      (click)="goToPage(currentPage + 1)"
    >次へ &gt;</button>
  </div>

  <ng-content
    *ngTemplateOutlet="
      table_template;
      context: { collection: displayedCustomers, total: displayedCustomers.length }
    "
  >
  </ng-content>
</div>

<ng-template #headerTemplate>
  <thead>
    <tr>
      <th *ngIf="isMgrMode" class="cheaderc_table__th cheaderc_table__th__ca-name">
        求職者担当
        <span
          *ngIf="caNameSortStatus === 'asc'"
          (click)="handlerCaNameSort()"
        >
          <img class="cheaderc_table__th__ca-name__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="caNameSortStatus === 'desc'"
          (click)="handlerCaNameSort()"
        >
          <img class="cheaderc_table__th__ca-name__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th *ngIf="isMgrMode" class="cheaderc_table__th cheaderc_table__th__mgr-memo">リーダー用メモ</th>
      <th class="cheaderc_table__th cheaderc_table__th__check5">稼働化5点チェック</th>
      <th class="cheaderc_table__th cheaderc_table__th__active">
        稼働
        <span
          *ngIf="activeSortStatus === 'asc'"
          (click)="handlerActiveSort()"
        >
          <img class="cheaderc_table__th__active__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="activeSortStatus === 'desc'"
          (click)="handlerActiveSort()"
        >
          <img class="cheaderc_table__th__active__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="cheaderc_table__th cheaderc_table__th__progress">
        進捗
        <span
          *ngIf="progressSortStatus === 'asc'"
          (click)="handlerProgressSort()"
        >
          <img class="cheaderc_table__th__progress__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="progressSortStatus === 'desc'"
          (click)="handlerProgressSort()"
        >
          <img class="cheaderc_table__th__progress__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="cheaderc_table__th cheaderc_table__th__day-change">
        前日増減
        <span
          *ngIf="dayChangeSortStatus === 'asc'"
          (click)="handlerDayChangeSort()"
        >
          <img class="cheaderc_table__th__day-change__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="dayChangeSortStatus === 'desc'"
          (click)="handlerDayChangeSort()"
        >
          <img class="cheaderc_table__th__day-change__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="cheaderc_table__th cheaderc_table__th__customer">
        求職者
        <span
          *ngIf="graduateYearSortStatus === 'asc'"
          (click)="handlerGraduateYearSort()"
        >
          <img class="cheaderc_table__th__customer__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="graduateYearSortStatus === 'desc'"
          (click)="handlerGraduateYearSort()"
        >
          <img class="cheaderc_table__th__customer__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="cheaderc_table__th cheaderc_table__th__interview">
        カウンセリング日
        <span
          *ngIf="interviewSortStatus === 'asc'"
          (click)="handlerInterviewSort()"
        >
          <img class="cheaderc_table__th__interview__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="interviewSortStatus === 'desc'"
          (click)="handlerInterviewSort()"
        >
          <img class="cheaderc_table__th__interview__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="cheaderc_table__th cheaderc_table__th__sf">
        SF
        <span
          *ngIf="sfSortStatus === 'asc'"
          (click)="handlerSfSort()"
        >
          <img class="cheaderc_table__th__sf__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="sfSortStatus === 'desc'"
          (click)="handlerSfSort()"
        >
          <img class="cheaderc_table__th__sf__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="cheaderc_table__th cheaderc_table__th__enterprise">
        <div class="th-enterprise-upper-area">ご支援想定企業</div>
        <div class="th-enterprise-lower-area">
          <span
            *ngIf="seminarAtSortStatus === 'asc'"
            (click)="handlerSeminarAtSort()"
          >
            選考日<img src="/assets/icons/arrow-up.png" />
          </span>
          <span
            *ngIf="seminarAtSortStatus === 'desc'"
            (click)="handlerSeminarAtSort()"
          >
            選考日<img src="/assets/icons/arrow-down.png" />
          </span>
          <span
            *ngIf="seminarStatusSortStatus === 'asc'"
            (click)="handlerSeminarStatusSort()"
          >
            ステータス<img src="/assets/icons/arrow-up.png" />
          </span>
          <span
            *ngIf="seminarStatusSortStatus === 'desc'"
            (click)="handlerSeminarStatusSort()"
          >
            ステータス<img src="/assets/icons/arrow-down.png" />
          </span>
        </div>
      </th>
      <th class="cheaderc_table__th cheaderc_table__th__enterprise">
        <div class="th-enterprise-upper-area">ご支援想定企業2</div>
        <div class="th-enterprise-lower-area">
          <span
            *ngIf="seminarAt2SortStatus === 'asc'"
            (click)="handlerSeminarAt2Sort()"
          >
            選考日<img src="/assets/icons/arrow-up.png" />
          </span>
          <span
            *ngIf="seminarAt2SortStatus === 'desc'"
            (click)="handlerSeminarAt2Sort()"
          >
            選考日<img src="/assets/icons/arrow-down.png" />
          </span>
          <span
            *ngIf="seminarStatus2SortStatus === 'asc'"
            (click)="handlerSeminarStatus2Sort()"
          >
            ステータス<img src="/assets/icons/arrow-up.png" />
          </span>
          <span
            *ngIf="seminarStatus2SortStatus === 'desc'"
            (click)="handlerSeminarStatus2Sort()"
          >
            ステータス<img src="/assets/icons/arrow-down.png" />
          </span>
        </div>
      </th>
      <th class="cheaderc_table__th cheaderc_table__th__enterprise-other">他候補企業</th>
      <th class="cheaderc_table__th cheaderc_table__th__enterprise-other">
        計上月
        <span
          *ngIf="expectedContractMonthSortStatus === 'asc'"
          (click)="handlerExpectedContractMonthSort()"
        >
          <img class="cheaderc_table__th__enterprise-other__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="expectedContractMonthSortStatus === 'desc'"
          (click)="handlerExpectedContractMonthSort()"
        >
          <img class="cheaderc_table__th__enterprise-other__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="cheaderc_table__th cheaderc_table__th__actions">&#8195;&#8195;</th>
      <th class="cheaderc_table__th cheaderc_table__th__memo-now">メモ</th>
      <th class="cheaderc_table__th cheaderc_table__th__memo-wish">志望順位</th>
      <th class="cheaderc_table__th cheaderc_table__th__memo-next">ネクストアクション</th>
      <th class="cheaderc_table__th cheaderc_table__th__last-contact">
        コンタクト
        <span
          *ngIf="pickUpMemoRegisterSortStatus === 'asc'"
          (click)="handlerPickUpMemoRegisterSort()"
        >
          <img class="cheaderc_table__th__second-match__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="pickUpMemoRegisterSortStatus === 'desc'"
          (click)="handlerPickUpMemoRegisterSort()"
        >
          <img class="cheaderc_table__th__second-match__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="cheaderc_table__th cheaderc_table__th__second-match">
        セカマ
        <span
          *ngIf="is2ndMatchSortStatus === 'asc'"
          (click)="handlerIs2ndMatchSort()"
        >
          <img class="cheaderc_table__th__second-match__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="is2ndMatchSortStatus === 'desc'"
          (click)="handlerIs2ndMatchSort()"
        >
          <img class="cheaderc_table__th__second-match__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="cheaderc_table__th cheaderc_table__th__introduce">
        最終求人紹介
        <span
          *ngIf="check5IntroduceSortStatus === 'asc'"
          (click)="handlerCheck5IntroduceSort()"
        >
          <img class="cheaderc_table__th__introduce__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="check5IntroduceSortStatus === 'desc'"
          (click)="handlerCheck5IntroduceSort()"
        >
          <img class="cheaderc_table__th__introduce__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="cheaderc_table__th cheaderc_table__th__apply">
        最終応募
        <span
          *ngIf="check5ApplySortStatus === 'asc'"
          (click)="handlerCheck5ApplySort()"
        >
          <img class="cheaderc_table__th__apply__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="check5ApplySortStatus === 'desc'"
          (click)="handlerCheck5ApplySort()"
        >
          <img class="cheaderc_table__th__apply__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="cheaderc_table__th cheaderc_table__th__mypage">
        ログイン
        <span
          *ngIf="mypageLoggedInAtSortStatus === 'asc'"
          (click)="handlerMypageLoggedInAtSort()"
        >
          <img class="cheaderc_table__th__mypage__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="mypageLoggedInAtSortStatus === 'desc'"
          (click)="handlerMypageLoggedInAtSort()"
        >
          <img class="cheaderc_table__th__mypage__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="cheaderc_table__th cheaderc_table__th__document">
        書類提出
        <span
          *ngIf="documentSubmissionStatusSortStatus === 'asc'"
          (click)="handlerDocumentSubmissionStatusSort()"
        >
          <img class="cheaderc_table__th__document__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="documentSubmissionStatusSortStatus === 'desc'"
          (click)="handlerDocumentSubmissionStatusSort()"
        >
          <img class="cheaderc_table__th__document__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
    </tr>
  </thead>
</ng-template>

<ng-template
  #table_template
  let-collection="collection"
  let-total="total"
>
  <table class="cheaderc_table" *ngIf="total && !loadingCustomer">
    <ng-content *ngTemplateOutlet="headerTemplate"></ng-content>
    <tbody>
      <tr
        *ngFor="let data of collection"
      >
        <td *ngIf="isMgrMode" class="cheaderc_table__td cheaderc_table__td__ca-name">{{ getCaName(data) }}</td>
        <td *ngIf="isMgrMode" class="cheaderc_table__td">
          <div class="cheaderc_table__td_mgr-memo">
            <textarea
              class="cheaderc_table__td_mgr-memo__text"
              [(ngModel)]= "data.dynamicData.mgrMemo"
            ></textarea>
            <button
              class="update-filter btn btn--blue btn--small"
              (click)="handleSaveMgrMemo(data.id, data.dynamicData.mgrMemo)"
            >更新</button>
          </div>
        </td>
        <td class="cheaderc_table__td">
          <div class="cheaderc_table__td_check5">
            <span
              class="cheaderc_table__td_check5__flag"
              [class.cheaderc_table__td_check5__flag--blue]="handlerCheck5SecondMatch(data?.dynamicData?.is2ndMatch)"
              [class.cheaderc_table__td_check5__flag--dark]="!handlerCheck5SecondMatch(data?.dynamicData?.is2ndMatch)"
            >
              セカマ設定
            </span>
            <span
              class="cheaderc_table__td_check5__flag"
              [class.cheaderc_table__td_check5__flag--blue]="handlerCheck5DocumentSubmissionStatus(data?.dynamicData?.documentSubmissionStatus)"
              [class.cheaderc_table__td_check5__flag--dark]="!handlerCheck5DocumentSubmissionStatus(data?.dynamicData?.documentSubmissionStatus)"
            >
              書類回収
            </span>
          </div>
          <div class="cheaderc_table__td_check5" style="margin-top: 4px;">
            <span
              class="cheaderc_table__td_check5__flag"
              [class.cheaderc_table__td_check5__flag--blue]="handlerCheck5PickupMemoStatus(data.id)"
              [class.cheaderc_table__td_check5__flag--dark]="!handlerCheck5PickupMemoStatus(data.id)"
            >
              直近接点
            </span>
            <span
              class="cheaderc_table__td_check5__flag-mini"
              [class.cheaderc_table__td_check5__flag-mini--blue]="data?.dynamicData?.check5Introduce"
              [class.cheaderc_table__td_check5__flag-mini--dark]="!data?.dynamicData?.check5Introduce"
            >
              紹介
            </span>
            <span
              class="cheaderc_table__td_check5__flag-mini"
              [class.cheaderc_table__td_check5__flag-mini--blue]="data?.dynamicData?.check5Apply"
              [class.cheaderc_table__td_check5__flag-mini--dark]="!data?.dynamicData?.check5Apply"
            >
              応募
            </span>
          </div>
        </td>
        <td class="cheaderc_table__td">
          <div class="cheaderc_table__td_active">
            <span class="cheaderc_table__td_active__data">
              {{ data.activeCount }}
            </span>
          </div>
        </td>
        <td class="cheaderc_table__td">
          <div class="cheaderc_table__td_progress">
            <span class="cheaderc_table__td_progress__data">
              {{ data.progressCount }}
            </span>
          </div>
        </td>
        <td class="cheaderc_table__td">
          <div class="cheaderc_table__td_day-change">
            <span
              class="cheaderc_table__td_day-change__data"
              [class.cheaderc_table__td_day-change__data--positive]="dayChanges[data.id]?.activeCountDayChange > 0"
              [class.cheaderc_table__td_day-change__data--negative]="dayChanges[data.id]?.activeCountDayChange < 0"
            >
              {{ dayChanges[data.id]?.activeCountDayChange != null ? (dayChanges[data.id].activeCountDayChange > 0 ? '+' : '') + dayChanges[data.id].activeCountDayChange : '-' }}
            </span>
            <span class="cheaderc_table__td_day-change__separator">/</span>
            <span
              class="cheaderc_table__td_day-change__data"
              [class.cheaderc_table__td_day-change__data--positive]="dayChanges[data.id]?.inProgressNumberDayChange > 0"
              [class.cheaderc_table__td_day-change__data--negative]="dayChanges[data.id]?.inProgressNumberDayChange < 0"
            >
              {{ dayChanges[data.id]?.inProgressNumberDayChange != null ? (dayChanges[data.id].inProgressNumberDayChange > 0 ? '+' : '') + dayChanges[data.id].inProgressNumberDayChange : '-' }}
            </span>
          </div>
        </td>
        <td class="cheaderc_table__td">
          <div class="cheaderc_table__td_customer">
            <div class="cheaderc_table__td_customer__above">
              <span class="cheaderc_table__td_customer__above__frontid">
                {{data?.frontId}}
              </span>
              <span
                *ngIf="data?.dynamicData?.academicFieldType"
                class="cheaderc_table__td_customer__above__flag"
                [class.cheaderc_table__td_customer__above__flag--pink]="
                  data?.dynamicData?.academicFieldType?.includes('文')
                "
                [class.cheaderc_table__td_customer__above__flag--blue]="
                  data?.dynamicData?.academicFieldType?.includes('理')
                "
                >{{
                  data?.dynamicData.academicFieldType.includes("文") ? "文" : "理"
                }}</span
              >
              <span
                *ngIf="data?.dynamicData?.academicHistory1?.graduateYear"
                class="cheaderc_table__td_customer__above__flagg cheaderc_table__td_customer__above__flagg--blue"
              >
                {{handlerGraduateYearView(data.dynamicData.academicHistory1.graduateYear) }} 卒
              </span>
              <span class="cheaderc_table__td_customer__above__rank">
                |&nbsp;{{data?.dynamicData.universityLevel | slice: 0 : 1}}&nbsp;|
              </span>
            </div>
            <div
              class="cheaderc_table__td_customer__under"
              (click)="onItemSelect(data)"
            >
              {{data?.fullName}}
            </div>
          </div>
        </td>
        <td class="cheaderc_table__td">
          <div class="cheaderc_table__td_date__above">
            <span
              *ngIf="data?.dynamicData?.interviewDate"
              class="cheaderc_table__td_date"
            >
              {{data?.dynamicData?.interviewDate | slice: 0 : 4}}
            </span>
          </div>
          <div class="cheaderc_table__td_date__under">
            <span
              *ngIf="data?.dynamicData?.interviewDate"
              class="cheaderc_table__td_date"
            >
              {{handlerDateMonthDay(data.dynamicData.interviewDate)}}
            </span>
          </div>
        </td>
        <td class="cheaderc_table__td">
          <div class="cheaderc_table__td_sf">
            <span
              *ngIf="data?.dynamicData?.rank"
              class="cheaderc_table__td_sf--flag cheaderc_table__td_sf--flag--{{ data.dynamicData.rank }}"
            >{{data.dynamicData.rank}}</span>
          </div>
        </td>
        <td class="cheaderc_table__td">
          <div class="cheaderc_table__td_enterprise">
            <div class="cheaderc_table__td_enterprise__above">
              <div class="cheaderc_table__td_enterprise__above__select-wrapper">
                <span class="cheaderc_table__td_enterprise__above__select-display">
                  {{ getExpectedCompanyShortLabel(expectedCompaniesUIList[data.id], expectedCompany[data.id]) }}
                </span>
                <select
                  class="cheaderc_table__td_enterprise__above__select-native"
                  [(ngModel)]="expectedCompany[data.id]"
                  (change)="handlerChangeExpectedCompany(data.id, expectedCompany[data.id])"
                >
                  <option
                    *ngFor="let item of expectedCompaniesUIList[data.id]"
                    [value]="item.value"
                    >{{ item.label }}</option
                  >
                </select>
              </div>
            </div>
            <div class="cheaderc_table__td_enterprise__under">
              <span
                *ngIf="expectedData[data.id]"
                class="cheaderc_table__td_enterprise__under__flagg"
                [class.cheaderc_table__td_enterprise__under__flagg--ag]="expectedData[data.id].p_type === 0"
                [class.cheaderc_table__td_enterprise__under__flagg--plus]="expectedData[data.id].p_type === 1"
              >{{handlerExpectedCompanyTypeView(expectedData[data.id].p_type)}}</span>

              <span *ngIf="expectedData[data.id]" class="cheaderc_table__td_enterprise__under__user">
                {{ expectedData[data.id].ra_u_name | truncate: 5 }}
              </span>
              <span *ngIf="expectedData[data.id]" class="cheaderc_table__td_enterprise__under__status">
                {{ handlerProgressStatusView(expectedData[data.id]) | truncate: 8 }}
              </span>
              <span *ngIf="expectedData[data.id] && expectedData[data.id].p_seminar_at" class="cheaderc_table__td_enterprise__under__date">
                {{ expectedData[data.id].p_seminar_at | date: "yyyy/MM/dd" }}
              </span>
            </div>
          </div>
        </td>
        <!-- ご支援想定企業2 -->
        <td class="cheaderc_table__td">
          <div class="cheaderc_table__td_enterprise">
            <div class="cheaderc_table__td_enterprise__above">
              <div class="cheaderc_table__td_enterprise__above__select-wrapper">
                <span class="cheaderc_table__td_enterprise__above__select-display">
                  {{ getExpectedCompanyShortLabel(expectedCompaniesUIList[data.id], expectedCompany2[data.id]) }}
                </span>
                <select
                  class="cheaderc_table__td_enterprise__above__select-native"
                  [(ngModel)]="expectedCompany2[data.id]"
                  (change)="handlerChangeExpectedCompany2(data.id, expectedCompany2[data.id])"
                >
                  <option
                    *ngFor="let item of expectedCompaniesUIList[data.id]"
                    [value]="item.value"
                    >{{ item.label }}</option
                  >
                </select>
              </div>
            </div>
            <div class="cheaderc_table__td_enterprise__under">
              <span
                *ngIf="expectedData2[data.id]"
                class="cheaderc_table__td_enterprise__under__flagg"
                [class.cheaderc_table__td_enterprise__under__flagg--ag]="expectedData2[data.id].p_type === 0"
                [class.cheaderc_table__td_enterprise__under__flagg--plus]="expectedData2[data.id].p_type === 1"
              >{{handlerExpectedCompanyTypeView(expectedData2[data.id].p_type)}}</span>
              <span *ngIf="expectedData2[data.id]" class="cheaderc_table__td_enterprise__under__user">
                {{ expectedData2[data.id].ra_u_name | truncate: 5 }}
              </span>
              <span *ngIf="expectedData2[data.id]" class="cheaderc_table__td_enterprise__under__status">
                {{ handlerProgressStatusView(expectedData2[data.id]) | truncate: 8 }}
              </span>
              <span *ngIf="expectedData2[data.id] && expectedData2[data.id].p_seminar_at" class="cheaderc_table__td_enterprise__under__date">
                {{ expectedData2[data.id].p_seminar_at | date: "yyyy/MM/dd" }}
              </span>
            </div>
          </div>
        </td>
        <td class="cheaderc_table__td">
          <div
            *ngFor="let expectedCompany of expectedCompaniesWithoutExpected[data.id]"
            class="cheaderc_table__td_enterprise-other"
          >
            <div class="cheaderc_table__td_enterprise-other__line">
              <span *ngIf="expectedCompany.e_name" class="cheaderc_table__td_enterprise-other__line__name">
                {{ handlerCompanyNameReplace(expectedCompany.e_name) | truncate: 7 }}
              </span>
              <span class="cheaderc_table__td_enterprise-other__line__status">
                {{ handlerProgressStatusView(expectedCompany) | truncate: 7 }}
              </span>
            </div>
          </div>
        </td>
        <!-- 計上月 -->
        <td class="cheaderc_table__td">
          <div class="date-pick-area">
            <input
              type="month"
              (change)="handleUpdateExpectedContractMonth($event, data)"
              [value]="getYearMonthFromDateString(data.dynamicData.expectedContractMonth)" />
          </div>
        </td>
        <td class="cheaderc_table__td">
          <div class="cheaderc_table__td_actions">
            <div class="cheaderc_table__td_actions__above">
              <a
                class="cheaderc_table__td_actions__chat"
                (click)="onItemSelect(data)"
              >
                <div class="cheaderc_table__td_actions__icon">
                  <img class="cheaderc_table__td_actions__img" src="/assets/images/phone.png" />
                </div>
              </a>
              <a
                class="cheaderc_table__td_actions__chat"
                (click)="
                  true
                    ? openChat(data?.dynamicData?.lineId)
                    : ''
                "
              >
                <div class="cheaderc_table__td_actions__icon">
                  <img class="cheaderc_table__td_actions__img" src="/assets/images/chat.png" />
                </div>
              </a>
            </div>
            <div class="cheaderc_table__td_actions__under">
              <a
                class="cheaderc_table__td_actions__chat"
                (click)="
                  data.dynamicData?.emailMain?.email &&
                  !data.dynamicData?.emailMain?.emailAvailable
                    ? openMailSend(sendConfig, data)
                    : ''
                "
              >
                <div class="cheaderc_table__td_actions__icon">
                  <img class="cheaderc_table__td_actions__img" src="/assets/images/mail.png" />
                </div>
              </a>
              <a
                class="cheaderc_table__td_actions__chat"
                (click)="onItemSelectAndMemo(data)"
              >
                <div class="cheaderc_table__td_actions__icon">
                  <img class="cheaderc_table__td_actions__img" src="/assets/images/note.png" />
                </div>
              </a>
            </div>
          </div>
        </td>
        <td class="cheaderc_table__td">
          <div class="cheaderc_table__td_memos">
            <textarea
              class="cheaderc_table__td_memos__text"
              [(ngModel)]= "pickUpMemo[data.id].situationMemoData.memo"
            ></textarea>
          </div>
        </td>
        <td class="cheaderc_table__td">
          <div class="cheaderc_table__td_memos">
            <textarea
              class="cheaderc_table__td_memos__text"
              [(ngModel)]= "pickUpMemo[data.id].situationMemoData.orderOfPreference"
            ></textarea>
            <button
              class="update-filter btn btn--blue btn--small"
              (click)="handleSaveMemo(data.id, pickUpMemo[data.id])"
            >更新</button>
          </div>
        </td>
        <td class="cheaderc_table__td">
          <div class="cheaderc_table__td_memos">
            <textarea
              class="cheaderc_table__td_memos__text"
              [(ngModel)]= "pickUpMemo[data.id].situationMemoData.nextAction"
            ></textarea>
          </div>
        </td>
        <td class="cheaderc_table__td">
          <div class="cheaderc_table__td_date__above">
            <span
              *ngIf="pickUpMemo[data.id].registerDate"
              class="cheaderc_table__td_date"
            >
              {{toJstDateStr(pickUpMemo[data.id].registerDate) | slice: 0 : 4}}
            </span>
          </div>
          <div class="cheaderc_table__td_date__under">
            <span
              *ngIf="pickUpMemo[data.id].registerDate"
              class="cheaderc_table__td_date"
            >
              {{handlerDateMonthDayPlusjp(toJstDateStr(pickUpMemo[data.id].registerDate))}}
            </span>
          </div>
        </td>
        <td class="cheaderc_table__td">
          <div
            *ngIf="data?.dynamicData?.is2ndMatch"
            class="cheaderc_table__td_text"
          >
            {{data.dynamicData.is2ndMatch}}
          </div>
        </td>
        <td class="cheaderc_table__td">
          <div class="cheaderc_table__td_date__above">
            <span
              *ngIf="data?.dynamicData?.check5Introduce"
              class="cheaderc_table__td_date"
            >
              {{data.dynamicData.check5Introduce | slice: 0 : 4}}
            </span>
          </div>
          <div class="cheaderc_table__td_date__under">
            <span
              *ngIf="data?.dynamicData?.check5Introduce"
              class="cheaderc_table__td_date"
            >
              {{handlerDateMonthDay(data.dynamicData.check5Introduce)}}
            </span>
          </div>
        </td>
        <td class="cheaderc_table__td">
          <div class="cheaderc_table__td_date__above">
            <span
              *ngIf="data?.dynamicData?.check5Apply"
              class="cheaderc_table__td_date"
            >
              {{data.dynamicData.check5Apply | slice: 0 : 4}}
            </span>
          </div>
          <div class="cheaderc_table__td_date__under">
            <span
              *ngIf="data?.dynamicData?.check5Apply"
              class="cheaderc_table__td_date"
            >
              {{handlerDateMonthDay(data.dynamicData.check5Apply)}}
            </span>
          </div>
        </td>
        <td class="cheaderc_table__td">
          <div class="cheaderc_table__td_date__above">
            <span
              *ngIf="data?.mypageLoggedInAt"
              class="cheaderc_table__td_date"
            >
              {{data.mypageLoggedInAt | slice: 0 : 4}}
            </span>
          </div>
          <div class="cheaderc_table__td_date__under">
            <span
              *ngIf="data?.mypageLoggedInAt"
              class="cheaderc_table__td_date"
            >
              {{handlerDateMonthDay(data.mypageLoggedInAt)}}
            </span>
          </div>
        </td>
        <td class="cheaderc_table__td">
          <div
            [class.cheaderc_table__td_text]="data?.dynamicData?.documentSubmissionStatus === 'OM有'"
            [class.cheaderc_table__td_text-large]="data?.dynamicData?.documentSubmissionStatus === '有'"
            [class.cheaderc_table__td_text-small]="data?.dynamicData?.documentSubmissionStatus === 'キャリアノート'"
          >
            {{data?.dynamicData?.documentSubmissionStatus}}
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</ng-template>

<ng-template
  #currencyCell
  let-value="currency"
  let-userId="userId"
  let-progressType="progressType"
  let-agentType="agentType"
  let-canceled="canceled"
>
  <td
    class="currency currency__clickable"
    [ngClass]="{ 'neg-value': value < 0, 'pos-value': value > 0 }"
    [routerLink]="['/sales/list']"
    [queryParams]="
      getSearchQueryParams(userId, progressType, agentType, canceled)
    "
  >
    {{ value | undef | number: "0.0-2" }}
  </td>
</ng-template>

<ng-template #totalCell let-value>
  <td
    class="currency"
    [ngClass]="{ 'neg-value': value < 0, 'pos-value': value > 0 }"
  >
    {{ value | undef | number: "0.0-2" }}
  </td>
</ng-template>
